import { RatingType } from "@archetypes/form";
import { range } from "@utils/generic.util";
import { PropsWithChildren } from "react";
import { TimeFormat } from "./generic";

export interface FormInputElement extends PropsWithChildren {
  className?: string;
  id?: string;
  name?: string;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  label?: string;
  labelClassName?: string;
  infoText?: string;
}

export type InputType = "text" | "email" | "password" | "number" | "tel" | "url" | "color";
export type FileType = "Excel" | "Image" | "Pdf" | "Docx" | "PPT";
export const InputTypes: InputType[] = ["text", "email", "password", "number", "tel"];
export const FileTypes: FileType[] = ["Excel", "Image", "Pdf", "Docx", "PPT"];

export const RatingTypes = [RatingType.Number, RatingType.Star];
export const ratingOptions = range(3, 11);

export enum FileTypeEnum {
  PDF = "application/pdf",
  IMAGE = "image/*",
  EXCEL = "application/vnd.ms-excel",
  DOCX = "application/docx",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  PPT = "application/vnd.ms-powerpoint",
}

export const enum FilterFileTypesEnum {
  DOCUMENT = "DOCUMENT",
  SPREADSHEET = "SPREADSHEET",
  PRESENTATION = "PRESENTATION",
  IMAGE = "IMAGE",
  PDF = "PDF",
}

export const FilterFileTypesArray = [
  FilterFileTypesEnum.DOCUMENT,
  FilterFileTypesEnum.SPREADSHEET,
  FilterFileTypesEnum.PRESENTATION,
  FilterFileTypesEnum.IMAGE,
  FilterFileTypesEnum.PDF,
];
export const FileTypeEnums = Object.values(FileTypeEnum);

export const FileTypeMap: Record<FileType, string> = {
  Image: "png, jpeg, jpg, webp, avif",
  Pdf: "pdf",
  Docx: "docx",
  Excel: "xls, xlsx",
  PPT: "ppt, pptx",
};

export const enum FileSizeUnit {
  MB = "MB",
  KB = "KB",
}

export const BYTE_SIZE = 1024;

export const FileSizeUnitTypes: FileSizeUnit[] = [FileSizeUnit.MB, FileSizeUnit.KB];
export const EMAIL_REGEX = /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;

export const TimeFormats = [TimeFormat.Twelve, TimeFormat.TwentyFour];

export const getTimeFormatLabel = (format: TimeFormat) => {
  switch (format) {
    case TimeFormat.Twelve:
      return "12";
    case TimeFormat.TwentyFour:
      return "24";
  }
};

export const FormulaFunctions = [
  { label: "SUM", value: "sum" },
  { label: "AVERAGE", value: "mean" },
  { label: "MIN", value: "min" },
  { label: "MAX", value: "max" },
  { label: "ROUND", value: "round" },
  { label: "ABS", value: "abs" },
  { label: "POWER", value: "pow" },
  { label: "SQUARE", value: "sqrt" },
  { label: "FLOOR", value: "floor" },
  { label: "MOD", value: "mod" },
  { label: "DATEDIF", value: "DATEDIF" },
  { label: "PERCENTAGE", value: "PERCENT" },
  { label: "DATEFORMAT", value: "DATEFORMAT" },
];
